import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';

import './index.less'
import { t } from '../../../languages';

const defaultData = [
    { option: 'good', value: 15 },
    { option: 'bad', value: 12 },
    { option: 'nc', value: 3 },
];

const BarStats = ({ lang, data = defaultData, title = 'responses' }) => {

    // Etiquetas traducidas
    const labels = {
        correcto: 'Correcto',
        incorrecto: 'Incorrecto',
        nulo: 'Nulo',
    };

    return (
        <div className="bar-chart-container">
            <h2>{t(lang, title)}</h2>
            <ResponsiveContainer width="100%" height={242}>
                <BarChart
                    data={data}
                    margin={{ top: 8, right: 8, left: 0, bottom: 8 }}
                >
                    {/* <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" /> */}
                    <XAxis
                        dataKey="option"
                        tickFormatter={(value) => t(lang, value)}
                        textAnchor="middle"
                        height={60}
                        fontWeight={700}
                        fontSize={'1em'}
                    />
                    {/* <YAxis
                        stroke="#666"
                        label={{ value: 'Frecuencia', angle: -90, position: 'insideLeft', offset: 10 }}
                    /> */}
                    <Tooltip
                        formatter={(value) => [value, 'Num']}
                        labelFormatter={(label) => t(lang, label)}
                        fontSize={'1em'}
                    />
                    <Bar
                        className='bar-stats'
                        dataKey="value"
                        radius={[4, 4, 0, 0]}
                        cursor="pointer"
                        label={{ position: 'top', fontWeight: 'bold' }}
                        fill="#8884d8"
                        fontSize={'1em'}
                    >
                        {data.map((entry, index) => (
                            <cell key={`cell-${index}`} fill={'red'} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default BarStats;